import { Component, output, signal } from '@angular/core';

import { ListingDetailsCtaVillagesDesktop } from './desktop/desktop';
import { ListingDetailsCtaVillagesMobile } from './mobile/mobile';

@Component({
  imports: [ListingDetailsCtaVillagesDesktop, ListingDetailsCtaVillagesMobile],
  selector: 'app-listing-details-cta-villages',
  styleUrl: './villages.css',
  templateUrl: './villages.html',
})
export class ListingDetailsCtaVillages {
  public readonly lppClicked = output();

  protected readonly footnote = signal(
    '* Daily prices are based on 2 guests per home, season & availability. Ranging from $129 daily to $229 daily.',
  );
  protected readonly image = signal('Pickleball_Tourney-124-optimized.jpg');
  protected readonly price = signal(129);
}
